import Vue from 'vue'
import Router from 'vue-router'
// import api from './fetch/api'

import notFound from './views/404.vue'
import Main from './views/Main.vue'
import Certificate from './views/Certificate.vue'
import Question from './views/Question.vue'

Vue.use(Router);

//
let routes = [
    {
        path: '/404',
        component: notFound,
        name: '',
        hidden: true
    },
    {
        path: '/search',
        component: Main,
        name: '查询',
        hidden: true,
    },
    {
        path: '/downLoad',
        component: Certificate,
        name: '下载证书',
        hidden: true,
    },
    {
        path: '/question',
        component: Question,
        name: '常见问题',
        hidden: true,
    },
];
const router = new Router({
    mode: 'history',
    routes
    /*: [
        { path: '*', component: notFound }
    ]*/
});

// import MenuUtils from '@/scripts/common/MenuUtils'
import axios from 'axios'


router.beforeEach((to, from, next) => {
   /* var explorer = window.navigator.userAgent.toLowerCase() ;
    //ie
    if (explorer.indexOf("msie") >= 0) {
        let ver = explorer.match(/msie ([\d.]+)/)[1];
        let hint = '您的ie浏览器当前版本过低，请升级到ie10及以上'
        if(ver < 10){
            alert(hint);
        }
        return false;
    }*/
    if (to.path == '/search') {
        sessionStorage.clear();
        next();
        return false;
    }
    if (to.path == '/downLoad') {
        next();
        return false;
    }
    if (to.path == '/question') {
        next();
        return false;
    }
    if (to.path == '/') {
        window.location.href = '/search';
        return false;
    }
   
    if (to.path != '/search') {
        window.location.href = '/search';
    } else {
        if (to.path) {
           axios.get('../static/version.json?_=' + Math.random()).then(response => {
                if (200 == response.status) {
                    if (typeof (response.data.version)!='undefined'&&process.env.VERSION !== response.data.version) {
                        window.location.reload(true);
                        return;
                    }
                    next();
                }
            }).catch(err => {
                next();
            });
            next();
            if(to.path=='/search'){
                history.pushState(null, null, document.URL);
            }
        } else {
            next({path: '/404'})
        }
    }
});
router.afterEach((to, from, next) => {
    document.title = '云半径';
});
export default router;


// WEBPACK FOOTER //
// ./src/routes.js